import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["href"];
const _hoisted_2 = { class: "title" };
const _hoisted_3 = { class: "sub-title" };
const _hoisted_4 = ["src"];
const _hoisted_5 = ["href"];
const _hoisted_6 = {
    key: 0,
    class: "comingSoon"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'ScrollThumbBlock',
    props: {
        title: {},
        subtitle: {},
        thumbs: {},
        rightimage: {},
        blur: { type: Boolean },
        href: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_slide_group = _resolveComponent("v-slide-group");
            return (_openBlock(), _createElementBlock("a", {
                href: _ctx.href != null ? _ctx.href : ''
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass('scroll-thumb-block ' + (_ctx.blur ? 'blur' : ''))
                }, [
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "title-col" }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
                                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.subtitle), 1)
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_col, { class: "rightimage-col v-col-2" }, {
                                default: _withCtx(() => [
                                    _createElementVNode("img", { src: _ctx.rightimage }, null, 8, _hoisted_4)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_slide_group, null, {
                                default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thumbs, (t, idx) => {
                                        return (_openBlock(), _createElementBlock("a", {
                                            key: idx,
                                            href: t.url
                                        }, [
                                            _createElementVNode("div", {
                                                class: "thumb",
                                                style: _normalizeStyle('background-image: url(' + t.img + ')')
                                            }, null, 4)
                                        ], 8, _hoisted_5));
                                    }), 128))
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    (_ctx.blur)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Coming Soon"))
                        : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "footer")
                ], 2)
            ], 8, _hoisted_1));
        };
    }
});
